import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const scrollTo = (id) => { if (location.pathname !== '/') { navigate('/'); setTimeout(() => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); }, 100); } else { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); } };

  return (
    <footer data-testid="site-footer" className="bg-stone-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          <div>
            <img src="/logo-white.png" alt="Domain Trademark Name" className="h-12 w-auto mb-4" />
            <p className="text-stone-500 text-sm leading-relaxed mb-6">Expert trademark registration, copyright protection, and business formation for US entrepreneurs.</p>
            <button onClick={onOpenContactForm} className="group inline-flex items-center gap-2 text-sm font-bold text-orange-500 hover:text-orange-400 transition-colors">
              Get Started <ArrowUpRight className="w-3.5 h-3.5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-200" />
            </button>
          </div>
          <div>
            <h4 className="font-sans font-bold text-stone-300 text-xs uppercase tracking-wider mb-5">Navigate</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'Pricing', 'Reviews', 'FAQ'].map((l) => (
                <li key={l}><button onClick={() => scrollTo(l.toLowerCase() === 'reviews' ? 'testimonials' : l.toLowerCase())} className="text-sm text-stone-500 hover:text-stone-200 transition-colors">{l}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-sans font-bold text-stone-300 text-xs uppercase tracking-wider mb-5">Services</h4>
            <ul className="space-y-3">
              {[{ l: 'Trademark Registration', p: '/services/trademark-registration' },{ l: 'Copyright Registration', p: '/services/copyright-registration' },{ l: 'Company Formation', p: '/services/company-formation' },{ l: 'Trademark Search', p: '/services/trademark-search' },{ l: 'Amazon Brand Registry', p: '/services/amazon-brand-registry' }].map((i) => (
                <li key={i.p}><Link to={i.p} className="text-sm text-stone-500 hover:text-stone-200 transition-colors">{i.l}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-sans font-bold text-stone-300 text-xs uppercase tracking-wider mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" /><a href="tel:+18005551234" className="text-sm text-stone-400 hover:text-stone-200 transition-colors">(800) 555-1234</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" /><a href="mailto:info@domaintrademarkname.com" className="text-sm text-stone-400 hover:text-stone-200 transition-colors">info@domaintrademarkname.com</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" /><span className="text-sm text-stone-400">7th Ave, New York, NY 10001</span></li>
            </ul>
          </div>
        </div>
        <div className="border-t-2 border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-600 text-xs">&copy; {currentYear} Domain Trademark Name. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy-policy" className="text-stone-600 hover:text-orange-500 transition-colors">Privacy Policy</Link>
            <Link to="/terms-conditions" className="text-stone-600 hover:text-orange-500 transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
